import { getRoleAsyncResponse } from "./types";
import * as roleActions from "./roles.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_ROLE, retrieveToken } from "../../../helpers/api";

export function* getRoles(action: ReturnType<typeof roleActions.getRoleAsync.request>) {
  try {
    const page = action.payload.page ? action.payload.page : 1;
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_ROLE.GET_ROLES(page), token);
    if (result.status === 200) {
      const parsed: getRoleAsyncResponse = yield call(result.json.bind(result));
      yield put(roleActions.getRoleAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roleActions.getRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roleActions.getRoleAsync.failure(parsed));
  }
}

export default function* rolesSagaGetRole() {
  yield takeEvery(roleActions.getRoleAsync.request, getRoles);
}
